/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */


const MaskInput = {

   ExpirationDate: (expiration) => {
      return expiration.replace(
         /[^0-9]/g, '' // To allow only numbers
     ).replace(
         /^([2-9])$/g, '0$1' // To handle 3 > 03
     ).replace(
         /^(1{1})([3-9]{1})$/g, '0$1/$2' // 13 > 01/3
     ).replace(
         /^0{1,}/g, '0' // To handle 00 > 0
     ).replace(
         /^([0-1]{1}[0-9]{1})([0-9]{1,2}).*/g, '$1/$2' // To handle 113 > 11/3
     );
   },

   ZipCode: (country, zip) => {
      if (country === 'US' || country === 'USA') {
         return zip.replace(/d{5}/)
      }

      if (country === 'CA' || country === 'CAN') {
         return zip.replace(
            /[^A-Za-z0-9]/g, '') // To allow only numbers and alphabet chars
            .replace(/^([A-Za-z]{1}[0-9]{1}[A-Za-z]{1})([0-9]{1}[A-Za-z]{1}[0-9]{1}).*/g, '$1 $2') // handle space A1A1A1 > A1A 1A1
      }  
   },

   Phone: (phone) => {
      let phoneNumber = phone.replace(
         /\D+/g, '')
         .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');

      return {
         maskInputVal: phoneNumber,
      };
   }
}

export default MaskInput;